// Banner replaced by sidebar alert dots in Sidebar.tsx.
export function GlobalAlarmBanner() { return null; }
